export default function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-accent-500/20 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-background-50/10 blur-2xl"></div>

          <div className="relative flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">随时随地 · 掌上观影</h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-5">
              爱豆影视全面适配移动端，手机浏览器打开即可享受高清流畅播放体验。无需下载APP，不占内存，随时随地追剧看电影，精彩内容触手可及。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-primary-600 font-semibold rounded-full text-sm cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap">
                <i className="ri-smartphone-line text-lg"></i>
                手机端观看
              </div>
              <div className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50/15 text-background-50 border border-background-50/30 font-medium rounded-full text-sm cursor-pointer hover:bg-background-50/25 transition-colors whitespace-nowrap">
                <i className="ri-tablet-line text-lg"></i>
                平板端观看
              </div>
            </div>
          </div>

          <div className="relative flex-shrink-0">
            <div className="w-48 md:w-56 h-auto rounded-2xl overflow-hidden border-4 border-background-50/20">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20movie%20streaming%20interface%20with%20dark%20theme%2C%20warm%20golden%20accent%20colors%2C%20video%20thumbnails%20arranged%20in%20a%20clean%20grid%2C%20minimalist%20UI%20design%2C%20soft%20screen%20glow%2C%20floating%20on%20a%20subtle%20gradient%20background%2C%20premium%20app%20aesthetic%2C%20no%20recognizable%20brands%20or%20logos&width=560&height=900&seq=app-mobile-01&orientation=portrait"
                alt="爱豆影视移动端观影体验"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}